import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Alert, IconButton, Snackbar } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

/**
 * PRX-124 — the "/" sign-in redirect carries a notice in the router state
 * when it could not use the role's landing page; this shows it on the page
 * the user lands on. Mounted once in AppContent, inside the router.
 */
const STATE_KEY = 'landingNotice';

export function landingNoticeState(notice: string | null): Record<string, string> | undefined {
  return notice ? { [STATE_KEY]: notice } : undefined;
}

export function LandingNotice() {
  const location = useLocation();
  const [dismissedKey, setDismissedKey] = useState<string | null>(null);
  const state = location.state as Record<string, unknown> | null;
  const notice = typeof state?.[STATE_KEY] === 'string' ? (state[STATE_KEY] as string) : null;

  if (!notice || dismissedKey === location.key) return null;

  return (
    <Snackbar open anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert
        severity="warning"
        action={
          <IconButton
            color="inherit"
            size="small"
            aria-label="Dismiss landing page notice"
            onClick={() => setDismissedKey(location.key)}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        {notice}
      </Alert>
    </Snackbar>
  );
}

export default LandingNotice;
